<template>
  <div id="w_box">
    <Header :searchPage="searchPage" @goPage="goPage"></Header>
    <div class="content">
      <div class="con_w">
        <WhrSearch/>
        <div id="tab04" class="con act">
          <div class="tbl">
            <table>
              <colgroup>
                <col width="110">
                <col width="*">
                <col width="100">
                <col width="105">
                <col width="100">
                <col width="65">
                <col width="65">
                <col width="65">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2" class="tp fst">종목코드</th>
                  <th scope="col" rowspan="2" class="tp">종목명</th>
                  <th scope="col" rowspan="2" class="tp">FY1</th>
                  <th scope="col" rowspan="2" class="tp"><div class="cols">투자의견<img src="https://img.thinkpool.com/concert/us/kiwoom/usRecode/img/tbl_w.gif" alt="내용" class="inv" @click="openMemo">
                    <div class="p_inv">
                      <div class="con">
                        Analysts' recommendation(1=Buy 5=Sell)
                      </div>
                      <div class="btn">
                        <a href="javascript:;" @click="closeMemo">X 닫기</a>
                      </div>
                    </div>
                    </div>
                  </th>
                  <th scope="col" rowspan="2" class="tp">EPS 예측치</th>
                  <th scope="col" colspan="3" class="tp lst">수익률<em>(%)</em></th>
                </tr>
                <tr>
                  <th scope="col">1주</th>
                  <th scope="col">1개월</th>
                  <th scope="col" class="lst">3개월</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item,index) in searchPage.items">
                  <DrecordSub :item="item" :key="index"/>
                </template>
              </tbody>
            </table>
            <!-- //table -->
          </div>
          <!-- //tbl -->

          <Pagination :searchPage="searchPage" @goPage="goPage"/>
          <!-- //paging -->

          <div class="guide">
            * 어닝 판단 기준 : 희석주당순이익 컨센서스 대비 변화율 <br>
            * 출처 : EDGAR 실적공시(8-K, 10-Q, 10-K), GAAP기준 (Non-GAAP 확보시 우선 적용) <br>
            * 공시 규격 6-K의 ADR종목은 제공되지 않음
          </div>
          <!-- //guide -->

          <div class="time">
            한국시간 기준 {{ curTime }}
          </div>
          <!-- //time -->
        </div>
      </div>
   </div>
  </div>
</template>

<script>
import Header from '@/components/kiwoom/usRecord/pc/common/Header'
import WhrSearch from '@/components/kiwoom/usRecord/pc/common/WhrSearch'
import DrecordSub from '@/views/kiwoom/usRecord/pc/Drecord_sub'
import {mapGetters} from 'vuex'
import Pagination from '@/components/common/Pagination'
import axios from 'axios'
import { EventBus } from '@/store/event-bus'

export default {
  components: {
    Header,
    WhrSearch,
    DrecordSub,
    Pagination
  },
  data () {
    return {
      searchPage: {
        pageNo: 1,
        pageSize: 14,
        totalRows: 0,
        items: []
      },
      curTime: new Date().toLocaleString()
    }
  },
  methods: {
    init () {
      const params = {
        chkIndex: this.getUsRecordSettings.chkIndex,
        pageNo: this.searchPage.pageNo,
        pageSize: this.searchPage.pageSize,
        symbol: this.getUsRecordSettings.symbol
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/consensus/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        if (res.data.resCode === '1') {
          this.searchPage.totalRows = res.data.resObj.totalRows
          this.searchPage.items = res.data.resObj.epsList
          this.curTime = new Date().toLocaleString()
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPage.pageNo = parseInt(pageNo)
      this.init()
    },
    openMemo () {
      $('.p_inv').toggle()
    },
    closeMemo () {
      $('.p_inv').hide()
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    getSyName () {
      return this.getUsRecordSettings.syName
    },
    getPageNo () {
      return this.searchPage.pageNo
    }
  },
  created () {
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }
    this.goPage('1')
    EventBus.$on('pageNo', (val) => {
      this.searchPage.pageNo = val
    })
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        if (val !== 'SYMBOL') {
          this.setSymbolDataReset()
        }
        this.goPage('1')
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        this.goPage('1')
      }
    },
    getSyName (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('syName', val)
      }
    },
    getPageNo (val, oldVal) {
      if (val !== oldVal) {
        EventBus.$emit('pageNo', val)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Drecord.vue